import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  splash: {
    bg: "rgb(240, 240, 240)",
    gradient:
      "linear-gradient(90deg,rgba(240, 240, 240, 0.5) 0,rgba(240, 240, 240, 0.5) 33.33%,rgba(240, 240, 240, 0) 44.1%,rgba(240, 240, 240, 0) 55.8%, rgba(240, 240, 240, 0.5) 66.66%, rgba(240, 240, 240, 0.5))",
    logoFill: "rgb(191, 191, 191)",
    progressBg: "rgb(230, 230, 230)",
    progressAfterBg: "#00A884",
    titleColor: "#111827",
    subTitleColor: "rgba(17, 24, 39, 0.55)",
    iconColor: "rgba(17, 24, 39, 0.35)",
  },
  layout: {
    bg: "#f3f4f6",
    contentBoxShadowColor: "0 18px 60px rgba(0, 0, 0, 0.18)",
  },
  sidebar: {},
  search: {
    iconColor: "#00A884",
  },
  options: {
    bg: "#ffffff",
    boxShadow: "0 12px 40px rgba(0, 0, 0, 0.18)",
  },
  unselectedChat: {
    bg: "#ffffff",
  },
  chatRoom: {
    bg: "#ffffff",
    scrollBtnBoxShadow: "0 14px 40px rgba(0, 0, 0, 0.18)",
    profileBoxShadow: "rgba(0, 0, 0, 0.10) 0px 12px 40px 0px",
    profileHeadingColor: "#00A884",
    profileActionColor: "rgb(223, 51, 51)",
  },
  common: {
    borderColor: "rgba(0, 0, 0, 0.08)",
    primaryColor: "#f3f4f6",
    mainHeadingColor: "#111827",
    subHeadingColor: "rgba(17, 24, 39, 0.55)",
    secondaryColor: "#ffffff",
    tertiaryColor: "#00A884",
    readIconColor: "#0da9e5",
    unreadIconColor: "#b3b3b3",
    headerIconColor: "rgba(17, 24, 39, 0.55)",

    // Surface tokens (glass UI + input)
    glassBg: "rgba(255, 255, 255, 0.85)",
    glassBorder: "rgba(0, 0, 0, 0.06)",
    glassShadow: "0 10px 24px rgba(0, 0, 0, 0.05)",
    inputBg: "rgba(17, 24, 39, 0.035)",
    inputBorder: "rgba(0, 0, 0, 0.06)",
  },
  alert: {
    infoColor: "#9de1fe",
    iconContainerColor: "white",
    closeIconColor: "#00000099",
  },
  badge: {
    textColor: "#111827",
    bgColor: "rgba(17, 24, 39, 0.06)",
  },
  sentMessage: {
    textColor: "#0b1f15",
    bgColor: "#dcfce7",
  },
  receivedMessage: {
    textColor: "#111827",
    bgColor: "#ffffff",
  },
  encryptionMessage: {
    bgColor: "#fdf4c5",
    textColor: "#111827",
  },
};
